import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { SHADOWS } from '@im/im-theme/constants';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var sizeBasedProps = {
  lg: {
    borderWidth: '8px',
    height: '48px',
    iconSize: '24px',
    padding: '12px',
    width: '48px'
  },
  md: {
    borderWidth: '6px',
    height: '40px',
    iconSize: '20px',
    padding: '10px',
    width: '40px'
  },
  sm: {
    borderWidth: '4px',
    height: '32px',
    iconSize: '16px',
    padding: '8px',
    width: '32px'
  },
  xl: {
    borderWidth: '10px',
    height: '56px',
    iconSize: '28px',
    padding: '14px',
    width: '56px'
  }
};
export function FeaturedIcon(props) {
  var iconId = props.Icon,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$iconTheme = props.iconTheme,
    iconTheme = _props$iconTheme === void 0 ? 'light-circle' : _props$iconTheme,
    onClick = props.onClick,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    sx = props.sx;
  var theme = useTheme();
  var bgAndBorderColors = {
    error: {
      backgroundColor: theme.palette.error[500],
      borderColor: theme.palette.error[600]
    },
    gray: {
      backgroundColor: theme.palette.gray[600],
      borderColor: theme.palette.gray[800]
    },
    primary: {
      backgroundColor: theme.palette.primary[600],
      borderColor: theme.palette.primary[700]
    },
    success: {
      backgroundColor: theme.palette.success[500],
      borderColor: theme.palette.success[600]
    },
    warning: {
      backgroundColor: theme.palette.warning[500],
      borderColor: theme.palette.warning[600]
    }
  };
  var themeBasedProps = {
    'dark-circle': {
      backgroundColor: bgAndBorderColors[color].backgroundColor,
      borderColor: bgAndBorderColors[color].borderColor,
      borderStyle: 'solid',
      color: theme.palette.common.white
    },
    'light-circle': {
      backgroundColor: theme.palette[color][100],
      color: theme.palette[color][600]
    },
    'light-circle-outline': {
      backgroundColor: theme.palette[color][100],
      borderColor: theme.palette[color][50],
      borderStyle: 'solid',
      color: theme.palette[color][600]
    },
    outline: {
      backgroundColor: theme.palette.common.white,
      border: "1px solid ".concat(theme.palette.gray[200]),
      boxShadow: theme.shadows[SHADOWS.xs],
      color: theme.palette.gray[700]
    }
  };
  return /*#__PURE__*/_jsx(Box, {
    onClick: onClick,
    sx: _extends({
      alignItems: 'center',
      borderRadius: '100%',
      display: 'inline-flex',
      justifyContent: 'center'
    }, sizeBasedProps[size], themeBasedProps[iconTheme], sx),
    "data-element": "Box",
    "data-component": "FeaturedIcon",
    "data-source-file": "FeaturedIcon.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      sx: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".MuiSvgIcon-root", {
        height: sizeBasedProps[size].iconSize,
        width: sizeBasedProps[size].iconSize
      }), "alignItems", 'center'), "color", themeBasedProps[iconTheme].color), "display", 'flex'), "height", sizeBasedProps[size].iconSize), "justifyContent", 'center'), "width", sizeBasedProps[size].iconSize),
      "data-element": "Box",
      "data-source-file": "FeaturedIcon.tsx",
      children: /*#__PURE__*/_jsx(Icon, {
        color: themeBasedProps[iconTheme].color,
        iconId: iconId,
        size: Number(sizeBasedProps[size].iconSize),
        "data-element": "Icon",
        "data-source-file": "FeaturedIcon.tsx"
      })
    })
  });
}